import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EbayItem } from '@contracts/interfaces/ebay.interface';
import { ConnectionService } from './connection.service';

@Injectable({
  providedIn: 'root'
})
export class EbayService {

    constructor(private http: HttpClient,
        private connectionService: ConnectionService ) {}

    test() {
        return this.http.post(this.connectionService.address + "/ebay-service/test", {});
    }

    getItem(itemID: string | number) {
        return this.http.post(this.connectionService.address + "/ebay-service/get-item", {itemID});
    }

    getItemStatus(itemID: string | number) {
        return this.http.post(this.connectionService.address + "/ebay-service/get-item-status", {itemID});
    }

    search (query: string) {

    }

    itemSpecifics(category: number) {
        return this.http.post(this.connectionService.address + "/ebay-service/item-specifics", {
          category
        });
    }

    getConditionIDsForCategory(category: number) {
        return this.http.post(this.connectionService.address + "/ebay-service/get-conditions-for-category", {category})
    }

    listItem(item: EbayItem) {
        return this.http.post(this.connectionService.address + "/ebay-service/list-item", {item});
    }

    reviseItem(item: EbayItem) {
        return this.http.post(this.connectionService.address + "/ebay-service/revise-item", {item});
    }

    removeItem(item: EbayItem) {
        return this.http.post(this.connectionService.address + "/ebay-service/remove-item", {item});
    }
}
